import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  colors,
  makeStyles,
  Typography,
  Button,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: colors.red[900],
  },
  actions: {
    backgroundColor: colors.red[900],
  },
  button: {
    color: "white",
    "&:hover": {
      backgroundColor: colors.red[800],
    },
  },
}));

const Warning = ({
  message,
  onCloseCancel = () => {},
  onCloseConfirm = () => {},
  openWarning = true,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleCloseCancel = () => {
    setOpen(false);
    onCloseCancel();
  };

  const handleCloseConfirm = () => {
    setOpen(false);
    onCloseConfirm();
  };

  useEffect(() => {
    setOpen(openWarning);
  }, [openWarning, setOpen]);

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <Box>
            <WarningIcon fontSize="large" className={classes.icon} />
          </Box>
          <Box mt={1}>
            <Typography variant="h3">Warning</Typography>
          </Box>
          <Box mt={1}>
            <Typography variant="body2">{message}</Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width={1}
        >
          <Button
            fullWidth
            className={classes.button}
            onClick={handleCloseConfirm}
          >
            Ok
          </Button>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width={1}
        >
          <Button
            fullWidth
            className={classes.button}
            onClick={handleCloseCancel}
          >
            Cancel
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default Warning;
